import axios from 'axios';
import Cookies from 'js-cookie';
import jwt from './jwt';

import config from '../config/environments';

const COCKPITLOGGED = 'CockpitLogged';

const headers = {
	'Content-Type': 'application/json',
};

const getToken = () => (Cookies.get(COCKPITLOGGED));

if (getToken()) {
	headers.Authorization = `Bearer ${getToken()}`;
}

const setNewToken = (token) => {
	Cookies.set(COCKPITLOGGED, token, { domain: '.webmotors.com.br' });
};

const client = axios.create({
	baseURL: config.APIUrl,
	withCredentials: true,
	headers,
});

const getRefreshedToken = async () => {
	const token = await client.post('/jwt/renewCockpitToken')
		.then(response => response.data)
		.catch(() => (getToken()));
	return token;
};

const isRefreshable = (percentTimeToExpire = 0.1) => {
	const token = getToken();
	if (!jwt.isExpired(token)) {
		const expire = jwt.getExpireTime(token);
		const timeNow = Math.floor(Date.now() / 1000);
		const percentToExpire = 1 - (timeNow / expire).toFixed(2);
		return percentToExpire < percentTimeToExpire;
	}
	return false;
};

const cockpit = {
	async refreshToken() {
		const token = await getRefreshedToken();
		setNewToken(token);
	},
	getRefreshedToken,
	isRefreshable,
	getToken,
};

export default cockpit;
